export default __webpack_public_path__ + "static/home1-90c71b90b7a941431c9b7ccecdf7b087.jpeg";